import {
  SIGN_IN,
  SIGN_OUT,
  UPDATE_OFFSET,
  SET_SCREEN_SCROLL_OFFSET,
  SET_CURRENT_PAGINATION_PAGE
} from './constants'
import { DEFAULT_SETTINGS } from '../../utils/paginationCoordinator'

const initialState = {
  offset: DEFAULT_SETTINGS.offset,
  screenScrollOffset: 0,
  screenPaginationPage: 0
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SIGN_IN: {
      return {
        ...state,
        user: {
          ...payload,
        }
      }
    }

    case SIGN_OUT: {
      return {
        ...state,
        user: initialState.user,
      }
    }

    case UPDATE_OFFSET: {
      return {
        ...state,
        offset: payload,
      }
    }

    case SET_SCREEN_SCROLL_OFFSET: {
      const { screen, offset } = payload

      return {
        ...state,
        screenScrollOffset: {
          ...state.screenScrollOffset,
          [screen]: offset,
        }
      }
    }

    case SET_CURRENT_PAGINATION_PAGE: {
      const { screen, page } = payload

      return {
        ...state,
        screenPaginationPage: {
          [screen]: { page }
        }
      }
    }

    default:
      return state
  }
}
